import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, Heart, Building2, Disc3, Box } from 'lucide-react';

const areas = [
  {
    to: '/student',
    title: 'Student',
    icon: GraduationCap,
    blurb: 'Paket för studentflak och firanden – ofta med leverans inom sydvästra Skåne.',
  },
  {
    to: '/brollop',
    title: 'Bröllop',
    icon: Heart,
    blurb: 'Tal, musik och stämning så gästerna hör varje ord och känner dansgolvet.',
  },
  {
    to: '/foretag',
    title: 'Företagsevent',
    icon: Building2,
    blurb: 'Konferens, kickoff, mässa och gala – från enkla paket till skräddarsydd rigg.',
  },
  {
    to: '/dj',
    title: 'DJ',
    icon: Disc3,
    blurb: 'Boka professionell DJ till fest, bröllop och företagsfest i Skåne – tydliga paket.',
  },
  {
    to: '/scen',
    title: 'Scen',
    icon: Box,
    blurb: 'Scenbygge, tross, ljus och LED – små podier till större produktion.',
  },
] as const;

/**
 * Kort översikt över verksamhetsområden på startsidan (SEO + navigation).
 */
const BusinessAreasSection: React.FC = () => {
  return (
    <section
      className="container mx-auto px-4 py-14 md:py-16"
      aria-labelledby="verksamhetsomraden-rubrik"
    >
      <div className="mx-auto max-w-3xl text-center mb-10 md:mb-12">
        <h2 id="verksamhetsomraden-rubrik" className="text-2xl md:text-3xl font-bold text-white mb-3">
          Våra verksamhetsområden
        </h2>
        <p className="text-slate-400 text-sm md:text-base leading-relaxed">
          Vi hyr ut och projektar ljud, ljus och scen för olika typer av event. Välj område nedan för paket,
          inspiration och offert – eller gå direkt till{' '}
          <Link to="/produkter" className="text-purple-400 underline hover:text-purple-300">
            produkter
          </Link>{' '}
          om ni redan vet vad ni söker. Behöver ni främst ljud till festen kan ni börja med{' '}
          <Link to="/hyra-hogtalare-malmo" className="text-purple-400 underline hover:text-purple-300">
            Hyra högtalare Malmö
          </Link>{' '}
          eller{' '}
          <Link to="/kompletta-festpaket" className="text-purple-400 underline hover:text-purple-300">
            kompletta festpaket
          </Link>{' '}
          – beskriv behovet, så hjälper vi er välja rätt nivå.
        </p>
      </div>
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5 list-none p-0 m-0">
        {areas.map(({ to, title, icon: Icon, blurb }) => (
          <li key={to}>
            <Link
              to={to}
              className="group flex h-full flex-col rounded-none border border-slate-800 bg-slate-900/40 p-5 text-left transition-colors hover:border-purple-500/40 hover:bg-slate-900/70"
            >
              <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-none border border-purple-500/30 bg-purple-950/40 text-purple-300 group-hover:border-purple-400/50 group-hover:text-purple-200">
                <Icon className="h-5 w-5" aria-hidden />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-purple-200">{title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed flex-grow">{blurb}</p>
              <span className="mt-4 text-sm font-medium text-purple-400 group-hover:text-purple-300">
                Läs mer →
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default BusinessAreasSection;
